// extracted by mini-css-extract-plugin
export default {"partnerships":"PreviousSponsorsCarousal_partnerships__-7wxN","sponsor":"PreviousSponsorsCarousal_sponsor__c-260"};